/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Menu,
  Dropdown,
  Button,
  message,
  Skeleton,
  Card,
} from "antd";
import { Link } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import { Map, TileLayer } from "react-leaflet";
import L from "leaflet";
import { ChartCard, MocoCard } from "../../../components/widget";
import Layout from "../../../layouts/MocoLayout";
import oRest from "../../../apis/rest";
import config from "./index.config";
import useWindowDimensions from "../../../helper/viewport";
import mData from "./data";
import Choropleth from "./Choropleth";
import "./index.scss";

const MAP_URL = `https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAP_API_KEY}`;
const ATTRIBUTION =
  '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
const API_URL = "webhook/dataquery/?qname=";

const menuCardStyle = {
  padding: 12,
  borderRadius: 16,
  color: "#fff",
  backgroundColor: "#1B6FBA",
  margin: "0px 12px 12px 0px",
  textAlign: "center",
};

const Page = () => {
  const [cards, setCards] = useState(config.cards);
  const [selectedAgama, setAgama] = useState("");
  const [selectedProvince, setProvince] = useState("");
  const [provinceMenu, setProvinceMenu] = useState([]);
  const agama = ["Khonghucu", "Hindu", "Buddha", "Kristen", "Katolik"];
  const [mapData, setMapData] = useState(null);
  const [mapSteps, setMapSteps] = useState(5);

  const { width } = useWindowDimensions();

  const toPascalCase = (params) => {
    return params.charAt(0).toUpperCase() + params.slice(1).toLowerCase();
  };

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}survey5agama_list_provinsi`;
      oRest
        .get(api)
        .then(({ data }) => {
          setProvinceMenu(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await oRest.get(
          `${API_URL}peta_sebaran_by_provinsi&agama=${selectedAgama}&provinsi=${selectedProvince}`
        );

        setMapSteps(data.length < 5 ? data.length : 5);

        const mapFeatures = mData.features.map((e) => {
          const temp = data.filter((element) => {
            return element.lembaga_provinsi === e.properties.provinsi;
          });

          return {
            ...e,
            properties: {
              ...e.properties,
              responden: temp[0] === undefined ? 0 : temp[0].count,
              ...temp[0],
            },
          };
        });

        setMapData({
          type: "FeatureCollection",
          features: mapFeatures,
        });
      } catch (error) {
        console.log(error);
        message.error("Terjadi kesalahan");
      }
    };
    fetchData();
  }, [selectedAgama, selectedProvince]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.tendikAkreditasi.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              tendikAkreditasi: {
                ...card.chart.tendikAkreditasi,
                options: {
                  ...card.chart.tendikAkreditasi.options,
                  chartOption: {
                    ...card.chart.tendikAkreditasi.options.chartOption,
                    series: [
                      {
                        ...card.chart.tendikAkreditasi.options.chartOption
                          .series[0],
                        data: data.map((e) => ({
                          name: e.status_akreditas,
                          value: e.count,
                        })),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.jenjangPendidik.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          const newData = [];
          data.forEach((datas) => {
            datas.lembaga_jenjangpendidikan.forEach((jenjang) => {
              newData.push({
                lembaga_jenjangpendidikan: jenjang,
                count: datas.count,
              });
            });
          });
          data = data.concat(newData);
          data = data.filter(
            (e) => !Array.isArray(e.lembaga_jenjangpendidikan)
          );
          data = data.sort((a, b) => a.count - b.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              jenjangPendidik: {
                ...card.chart.jenjangPendidik,
                options: {
                  ...card.chart.jenjangPendidik.options,
                  chartOption: {
                    ...card.chart.jenjangPendidik.options.chartOption,
                    yAxis: {
                      ...card.chart.jenjangPendidik.options.chartOption.yAxis,
                      data: data.map((e) => e.lembaga_jenjangpendidikan),
                    },
                    series: [
                      {
                        ...card.chart.jenjangPendidik.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    if (selectedAgama !== "") {
      fetchData();
    }
  }, [selectedProvince, selectedAgama]);

  const handleFilterAgama = (value) => {
    setAgama(value.key === "all" ? "" : value.key);
  };

  const handleFilterProvinsi = (value) => {
    setProvince(value.key === "all" ? "" : value.key);
  };

  const agamaMenu = (
    <Menu onClick={handleFilterAgama}>
      <Menu.Item key="all">Semua Agama</Menu.Item>
      {agama.map((e) => {
        return <Menu.Item key={e}>{e}</Menu.Item>;
      })}
    </Menu>
  );

  const provinceDropdownMenu = (
    <Menu onClick={handleFilterProvinsi}>
      <Menu.Item key="all">Nasional</Menu.Item>
      {provinceMenu
        ?.map((e) => e.lembaga_provinsi)
        .sort((a, b) =>
          // eslint-disable-next-line no-nested-ternary
          a > b ? 1 : b > a ? -1 : 0
        )
        .map((e) => {
          return <Menu.Item key={e}>{toPascalCase(e)}</Menu.Item>;
        })}
    </Menu>
  );

  return (
    <Layout>
      <div
        style={{
          display: "flex",
          flexFlow: "row",
          flexWrap: "wrap",
          justifyContent: width > 795 ? "space-between" : "center",
        }}
      >
        <div>
          <Row justify={width > 795 ? "start" : "center"}>
            <Link to="/pendidikan-keagamaan/1" key="overview">
              <Col style={menuCardStyle}>
                <span className="text-default">Overview</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/2" key="lembaga">
              <Col style={menuCardStyle}>
                <span className="text-default">Lembaga</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/3" key="sdm">
              <Col style={menuCardStyle}>
                <span className="text-default">SDM</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/4" key="sarana">
              <Col style={menuCardStyle}>
                <span className="text-default">Sarana</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/5" key="pendidikan">
              <Col style={menuCardStyle}>
                <span className="text-default">Pendidikan</span>
              </Col>
            </Link>
          </Row>
        </div>
        <div>
          <Row justify={width > 795 ? "start" : "center"}>
            <Col>
              <Dropdown overlay={agamaMenu}>
                <Button
                  size="large"
                  shape="round"
                  style={{
                    backgroundColor: "#1B6FBA",
                    color: "#fff",
                  }}
                >
                  Pilih agama &nbsp;
                  <DownOutlined />
                </Button>
              </Dropdown>
            </Col>
            <Col>
              <Dropdown
                overlay={provinceDropdownMenu}
                overlayStyle={{ height: 300, overflowY: "auto" }}
              >
                <Button
                  size="large"
                  shape="round"
                  style={{
                    backgroundColor: "#1B6FBA",
                    color: "#fff",
                  }}
                >
                  Pilih provinsi &nbsp;
                  <DownOutlined />
                </Button>
              </Dropdown>
            </Col>
          </Row>
        </div>
      </div>
      <Row
        gutter={[24, 24]}
        style={{ paddingTop: "8px" }}
        id="PendidikanLembaga"
      >
        <Col span={24}>
          <Card
            style={{
              borderRadius: 16,
            }}
          >
            <span
              style={{
                fontSize: 26,
                fontWeight: 500,
                color: "#1B6FBA",
              }}
            >
              {`Sebaran Data ${
                selectedAgama === "" ? "Semua Agama" : `Agama ${selectedAgama}`
              } di ${
                selectedProvince === ""
                  ? "Seluruh Provinsi"
                  : `Provinsi ${selectedProvince}`
              }`}
            </span>
          </Card>
        </Col>
        <Col span={14}>
          <MocoCard {...cards.map.content}>
            <div
              style={{
                minHeight: 600,
              }}
            >
              <Skeleton loading={!mapData}>
                <Map
                  zoom={5}
                  minZoom={4}
                  maxZoom={12}
                  center={[2.0450883, 113.3616476]}
                  maxBounds={L.latLngBounds(
                    [11.83222, 95.004448],
                    [-18.680253, 153.691949]
                  )}
                >
                  <TileLayer attribution={ATTRIBUTION} url={MAP_URL} />
                  <Choropleth mapData={mapData} mapSteps={mapSteps} />
                </Map>
              </Skeleton>
            </div>
          </MocoCard>
        </Col>
        <Col span={10}>
          <ChartCard {...cards.chart.tendikAkreditasi} />
          <br />
          {selectedAgama === "" ? (
            <MocoCard {...cards.map.warning}>
              <div className="text-header" style={{ textAlign: "center" }}>
                Mohon untuk memilih agama terlebih dahulu
              </div>
            </MocoCard>
          ) : (
            <ChartCard {...cards.chart.jenjangPendidik} />
          )}
        </Col>
      </Row>
    </Layout>
  );
};

export default Page;
